import { type FC } from 'react'

import Triangle from '@/assets/icons/icon-warning.svg'
import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'
import { DESKTOP_APP_VERSION_TO_FORCE_UPDATE } from '@/modules/desktop/consts'

interface Props extends DialogProps {}

// TODO: Remove this once we no longer receive error log from users
export const DesktopUpdateDialog: FC<Props> = ({ isOpen, onClose }) => {
  const handleClickDownload = () => {
    window.open('https://www.creatorhero.com/download', '_blank')
    onClose()
  }

  const handleClickRemindLater = () => {
    onClose()
  }

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      panelClassName="lg:max-w-[560px]"
    >
      <Dialog.Header>
        <Dialog.Title>App Update Required</Dialog.Title>
        <Dialog.Description className="text-center">
          Your desktop app version ({DESKTOP_APP_VERSION_TO_FORCE_UPDATE}) needs
          to be updated manually to continue receiving updates and access the
          latest features.
        </Dialog.Description>
      </Dialog.Header>

      <div className="mt-6 space-y-4">
        <div className="rounded-lg bg-yellow-50 dark:bg-yellow-900/20 p-4 border border-yellow-200 dark:border-yellow-800">
          <div className="flex">
            <div className="flex-shrink-0">
              <Triangle />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                Critical Update Required
              </h3>
              <div className="mt-2 text-sm text-yellow-700 dark:text-yellow-300">
                <p>
                  You’re currently using an outdated version (
                  {DESKTOP_APP_VERSION_TO_FORCE_UPDATE}) that can’t receive
                  updates automatically. Please download the latest version to
                  unlock important improvements, new features, and bug fixes.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100">
            To fix this issue:
          </h4>
          <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700 dark:text-gray-300">
            <li>Click &quot;Download Latest Version&quot; below</li>
            <li>Close this desktop app completely</li>
            <li>Install the downloaded version</li>
            <li>Restart the app to enjoy the latest features</li>
          </ol>
        </div>
      </div>

      <Dialog.Footer className="flex gap-2 mt-6">
        <Button
          variant="outline"
          onClick={onClose}
          className="flex-1"
        >
          Remind Me Later
        </Button>
        <Button
          onClick={handleClickDownload}
          className="flex-1"
        >
          Download Latest Version
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
